import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ChannelName } from '../../types';
import { T_KEYS } from '../../constants';
import {
  ManageHeader,
  ManageHeaderLeft,
  ManageHeaderInfo,
  ManageHeaderTitle,
  ManageHeaderDescription,
  ChannelLogoLarge,
  BackArrow,
  AddAccountButton,
} from '../../styles/ManageChannelStyles';

// Import unified channel logo components
import { ChannelLogo, ChannelLogoType } from '../ChannelLogos';

// Icons
const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M19 12H5M12 19l-7-7 7-7" />
  </svg>
);

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

interface IChannelManageHeaderProps {
  channelName: ChannelName;
  channelDisplayName: string;
  onAddAccount: () => void;
  onBack: () => void;
}

const ChannelManageHeader: FC<IChannelManageHeaderProps> = memo(({
  channelName,
  channelDisplayName,
  onAddAccount,
  onBack,
}) => {
  const { t } = useTranslation();

  // Map channelName to ChannelLogoType
  const channelLogoType: ChannelLogoType = channelName as ChannelLogoType;

  return (
    <ManageHeader>
      <ManageHeaderLeft>
        <BackArrow onClick={onBack} aria-label={t(T_KEYS.BACK)}>
          <ArrowIcon />
        </BackArrow>
        <ChannelLogo channel={channelLogoType} size="lg" rounded />
        <ManageHeaderInfo>
          <ManageHeaderTitle>
            {t(T_KEYS.CHANNEL_ACCOUNTS, { channel: channelDisplayName })}
          </ManageHeaderTitle>
          <ManageHeaderDescription>
            {t(T_KEYS.MANAGE_CHANNEL_DESCRIPTION, { channel: channelDisplayName })}
          </ManageHeaderDescription>
        </ManageHeaderInfo>
      </ManageHeaderLeft>

      <AddAccountButton onClick={onAddAccount}>
        {t(T_KEYS.ADD_NEW_ACCOUNT, { channel: channelDisplayName })}
        <PlusIcon />
      </AddAccountButton>
    </ManageHeader>
  );
});

ChannelManageHeader.displayName = 'ChannelManageHeader';

export default ChannelManageHeader;
